// Helper function to check if dark mode should be enabled
// globally set to false until we turn dark mode back on
const shouldEnableDarkMode = () => {
  // const isProduction = window.APP_ENV === 'prod' || window.APP_ENV === 'production';
  // if (isProduction) {
  //   return false;
  // }
  // return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  return false;
};

export const reactSelectReset = {
  control: (provided, state) => ({
    ...provided,
    ...(state.isMulti
      ? {
          // For multi-select, do not set height/minHeight so it can expand
          marginTop: '0.75rem',
        }
      : {
          height: '2.25rem',
          minHeight: '2.25rem',
          marginTop: '0.75rem',
        }),
    // tw equivalent of zinc-950/10, default for all our other catalyst components
    borderColor: state.isDisabled
      ? 'rgba(9, 9, 11, 0.2)' // zinc-950/20 when disabled
      : 'rgba(9, 9, 11, 0.1)',
    borderRadius: '8px',
    padding: '0',
    backgroundColor: state.isDisabled
      ? 'rgba(255, 255, 255, 0.025)' // white/[2.5%] when disabled
      : '#ffffff',
    boxShadow: state.isFocused
      ? '0 0 0 2px #0493a1'
      : state.isDisabled
        ? 'none'
        : '0 1px 2px rgba(0, 0, 0, 0.125)',
    transition: 'box-shadow 0.2s ease-in-out',
    opacity: state.isDisabled ? 0.5 : 1, // Match Input's disabled opacity
    ...(shouldEnableDarkMode() && {
      backgroundColor: state.isDisabled
        ? 'rgba(255, 255, 255, 0.025)' // white/[2.5%] when disabled
        : 'rgba(255, 255, 255, 0.05)',
      borderColor: state.isDisabled
        ? 'rgba(255, 255, 255, 0.15)' // white/15 when disabled
        : 'rgba(255, 255, 255, 0.1)',
    }),
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    ...(state.isMulti
      ? {
          // For multi-select, do not set height so it can expand
          padding: '0 0.875rem',
          display: 'flex',
          alignItems: 'center',
        }
      : {
          height: '2.25rem',
          padding: '0 0.875rem',
          display: 'flex',
          alignItems: 'center',
        }),
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '0.375rem',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
    ...(shouldEnableDarkMode() && {
      backgroundColor: 'rgb(82, 82, 91)',
      borderColor: 'rgba(255, 255, 255, 0.1)',
    }),
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '0.5rem 1rem',
    backgroundColor: state.isSelected ? '#0493a1' : state.isFocused ? '#026875' : 'transparent',
    color: state.isSelected || state.isFocused ? '#ffffff' : '#171717',
    ...(shouldEnableDarkMode() && {
      color: 'rgba(255, 255, 255, 0.9)',
    }),
    cursor: 'pointer',
    ':active': {
      backgroundColor: '#0493a1',
      color: '#ffffff',
    },
  }),
  input: (provided) => ({
    ...provided,
    color: '#171717',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#171717',
    ...(shouldEnableDarkMode() && {
      color: 'rgba(255, 255, 255, 0.9)',
    }),
  }),
  multiValue: (provided) => ({
    ...provided,
    ...(shouldEnableDarkMode() && {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    }),
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    ...(shouldEnableDarkMode() && {
      color: 'rgba(255, 255, 255, 0.9)',
    }),
  }),
};
